import { VApp } from 'vuetify/lib/components/VApp';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VApp,[_c(VContainer,{attrs:{"fill-height":"","fluid":""}},[_c(VRow,{attrs:{"justify":"center"}},[_c(VCol,{attrs:{"align":"center"}},[_c(VIcon,{attrs:{"size":"7rem"}},[_vm._v("mdi-magnify")]),_c('br'),_c('p',{staticClass:"display-2"},[_vm._v("404 - file not found")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }